import { Configuration, NavigationClient, PublicClientApplication, SilentRequest } from '@azure/msal-browser'
import { NavigateFunction } from 'react-router-dom'

const frontendUrl = import.meta.env.VITE_FRONTEND_URL
const backendUrl = import.meta.env.VITE_BACKEND_URL
const novuAppIdentifier = import.meta.env.VITE_NOVU_APP_IDENTIFIER

// Microsoft Entra External ID Configuration
const tenantSubdomain = import.meta.env.VITE_ENTRA_TENANT_SUBDOMAIN
const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID
const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID
const apiScope = import.meta.env.VITE_ENTRA_API_SCOPE

if (!frontendUrl) throw 'Invalid configuration. Please set VITE_FRONTEND_URL.'
if (!backendUrl) throw 'Invalid configuration. Please set VITE_BACKEND_URL.'
if (!novuAppIdentifier) throw 'Invalid configuration. Please set VITE_NOVU_APP_IDENTIFIER.'
if (!tenantSubdomain) throw 'Invalid configuration. Please set VITE_ENTRA_TENANT_SUBDOMAIN.'
if (!tenantId) throw 'Invalid configuration. Please set VITE_ENTRA_TENANT_ID.'
if (!clientId) throw 'Invalid configuration. Please set VITE_ENTRA_CLIENT_ID.'
if (!apiScope) throw 'Invalid configuration. Please set VITE_ENTRA_API_SCOPE.'

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://${tenantSubdomain}.ciamlogin.com/${tenantId}`,
    knownAuthorities: [`${tenantSubdomain}.ciamlogin.com`],
    redirectUri: frontendUrl,
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
}

export const apiConfig = {
  scopes: [apiScope],
  webApiUri: backendUrl,
}

/** Shared MSAL instance - use this single instance across the entire app to ensure consistent auth state. */
export const msalInstance = new PublicClientApplication(msalConfig)

/** Request configuration that adds scopes here for ID token to be used at Microsoft identity platform endpoints. */
export const loginRequest: SilentRequest = {
  scopes: apiConfig.scopes,
}

export {
  /** Application identifier for Novu, set as VITE_NOVU_APP_IDENTIFIER in environment variables */
  novuAppIdentifier,
}

// https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/performance.md
export class CustomNavigationClient extends NavigationClient {
  private navigate: NavigateFunction

  constructor(navigate: NavigateFunction) {
    super()
    this.navigate = navigate
  }

  async navigateInternal(url: string, options: { noHistory?: boolean }): Promise<boolean> {
    if (options.noHistory) {
      this.navigate(url, { replace: true })
    } else {
      this.navigate(url)
    }
    return false
  }
}
